// extracted by mini-css-extract-plugin
export var container = "_bq-1";
export var cornerButtonContainer = "_bq-5";
export var disabled = "_bq-2";
export var fileContainer = "_bq-4";
export var hiddenInput = "_bq-3";
export var widthContainer = "_bq-0";